/* eslint-disable */
import { TbBrandSpeedtest } from "react-icons/tb";
import { BsCodeSlash } from "react-icons/bs";
import { AiOutlineHourglass, AiOutlineCloud, AiOutlineApartment, AiOutlineDatabase, AiOutlineApi } from "react-icons/ai";
import {BiMobileLandscape} from 'react-icons/bi';
import {GrSecure} from 'react-icons/gr';

export const servicesData = [
    // {
    //     id: 1,
    //     title: 'Marketing',
    //     icon: <BiShoppingBag/>
    // },
    {
        id: 6,
        title: 'Pretty UI/UX',
        icon: <BsCodeSlash />
    },
    {
        id: 7,
        title: 'Responsive Design',
        icon: <BiMobileLandscape/>
    },
    {
        id: 8,
        title: 'Scalable API',
        icon: <AiOutlineApi />
    },
    {
        id: 9,
        title: 'Clouding',
        icon: <AiOutlineCloud />
    },
    {
        id: 10,
        title: 'Strong Authentication', 
        icon: <GrSecure />
    },
    {
        id: 11,
        title: 'Performance Optimization',
        icon: <AiOutlineHourglass />
    },
    // {
    //     id: 12,
    //     title: 'Audio Transcription',
    //     icon: <AiFillAudio />
    // },
    {
        id: 13,
        title: 'Unit/Integration Tests',
        icon: <TbBrandSpeedtest />
    },
    {
        id: 2,
        title: 'Database Design',
        icon: <AiOutlineDatabase />
    },
    {
        id: 3,
        title: 'System Architecture',
        icon: <AiOutlineApartment />
    },
    // {
    //     id: 4,
    //     title: 'Internet Research',
    //     icon: <FaInternetExplorer />
    // },
    // {
    //     id: 5,
    //     title: 'Tutoring',
    //     icon: <FaChalkboardTeacher />
    // },


]

// Uncomment your required service.
// Couldn't find the required services? Raise an issue on github at https://github.com/hhhrrrttt222111/developer-portfolio/issues/new
// You can also add on your own 😉.